import React from 'react';
import { Sun, Moon } from 'lucide-react';

export const ThemeToggleButton = ({ theme, onToggle, className = '' }) => (
  <button
    onClick={onToggle}
    title={theme === 'dark' ? 'الوضع النهاري' : 'الوضع الليلي'}
    aria-label="تبديل المظهر"
    className={`flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-white/[0.04] text-slate-200 transition-colors hover:border-teal-500/50 hover:text-teal-300 ${className}`}
    data-testid="public-theme-toggle-btn"
  >
    {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
  </button>
);

export default ThemeToggleButton;
